<template>
  <div class="user-vip">
    <df-tabs class="tabs" :tabs="tabs" @change="tabChange" v-model="currTab"></df-tabs>
    <div class="vip-inner">
      <div class="my-content" v-if="tab === 'my'">
        <template v-if="myTable && myTable.length">
          <i-table :data="myTable" :columns="myColumns" stripe></i-table>
          <div class="download-app">
            <div class="tip lh1">下载APP畅享更多会员课程</div>
            <div class="app-list flex fww tac">
              <template v-for="(app, i) in (dfAppList || myTable)">
                <div class="app flex-col jcb aic" :key="i" v-show="app.name">
                  <img :src="app.logo" alt="" class="app-logo">
                  <span class="app-name wot1">{{app.name}}</span>
                  <div class="download csp unselect" @click="OpenRouter('/download?aid=' + app.product_id)">去下载</div>
                </div>
              </template>
            </div>
          </div>
        </template>
        <mine-no-data @link-to="ShowVip()"
                      v-else
                      type="my-vip"
                      tips="您还不是我们的vip会员哦，点亮VIP畅享所有VIP课程！"
                      to-home-text="开通会员"
                      hidden-list></mine-no-data>
      </div>
      <div class="record-content" v-else-if="tab === 'record'">
        <template v-if="recordTable && recordTable.length">
          <i-table :data="recordTable" :columns="recordColumns" stripe></i-table>
          <df-page :total="recordTotal" :current="recordCurr" :page-size="recordLimits"
                   @change="recordPageChange" class="pt20"></df-page>
        </template>
        <mine-no-data @link-to="$router.push('/user/remark')"
                      v-else
                      type="my-record"
                      tips="暂无订购记录，了解下现有什么优惠套餐吧！"
                      to-home-text="去看看"
                      hidden-list></mine-no-data>
      </div>
      <div class="exchange-content" v-else>
        <img src="../../../assets/images/user/exchange_vip_top.png" alt="" class="exchange-top w100 vat">
        <div class="user-phone flex aic jcb lh1">
          <div class="user-phone-inner flex aic">
            <span>您好，{{userInfo.username}}（{{userInfo.phone}}）</span>
            <span @click="ToLogin()" class="flex aic change-user csp"><i class="mine-ico img change"></i>切换账号</span>
          </div>
          <span class="tips">注：兑换成功的会员卡期限将自动叠加到当前账号</span>
        </div>
        <div class="code-input flex jcb aic tac">
          <input @keydown.enter.prevent="userCode" v-model="exchangeCode" type="text" class="code-input-inner tac"
                 placeholder="请输入兑换码，注意大小写"/>
          <div class="exchange-button flex-1 csp" @click="userCode">立即兑换</div>
        </div>
        <div class="notice unselect">
          <div class="notice-tip">使用须知</div>
          <div class="notice-inner">
            <div class="notice-row" v-for="text in notice">{{text}}</div>
            <div class="notice-row">更多问题，点击<span class="help csp" @click="$router.push('/footer/details?type=help')">帮助中心</span>查看
            </div>
          </div>
        </div>
        <div class="subtitle change-his">兑换记录</div>
        <div class="change-list flex aic jcb fww ovh">
          <div class="change-item flex aic bsb" v-for="(item, i) in exchangeList" :key="i">
            <i class="exchange-icon vam mine-ico img"></i>
            <div class="exchange-detail flex-1 flex-col jce h100">
              <div class="exchange-name">{{item.typename}}</div>
              <div class="exchange-code">兑换码：{{item.name}}</div>
              <div class="exchange-time">兑换时间：{{item.updatetime && Tools.formatDate(item.updatetime,
                'Y年M月D日HH:mm:ss')}}
              </div>
            </div>
          </div>
          <div class="show-all csp mt15 w100 mine-ico arrow-down flex aic jcc"
               v-show="moreExchange && moreExchange.length"
               @click="moreExchange = exchangeList.push(...moreExchange) && []">查看全部
          </div>
          <div class="no-exchange w100 tac" v-show="!exchangeList || !exchangeList.length">暂无兑换信息</div>
        </div>
        <div class="subtitle hot">热门课程</div>
        <div class="hot-list flex jcb">
          <course-card :item="course"
                       image-width="128"
                       image-height="146"
                       :img-key="(course.wh_id || course.bj_id) ? 'bigimg' : 'bgimg'"
                       :class="{'only-big': course.wh_id || course.bj_id}"
                       width="128"
                       @detail="toCourse"
                       v-for="(course, i) in hotList" :key="i"></course-card>
        </div>
        <div class="subtitle remark">VIP会员权益</div>
        <mine-remark></mine-remark>
        <div class="more-remark mlr-auto csp tac" @click="$router.push('/user/remark')">去了解更多</div>
      </div>
    </div>
  </div>
</template>

<script>
  import Mixins from '@/mixins/mixins';
  import {mapGetters} from 'vuex';

  export default {
    name: "UserVip",
    mixins: [Mixins.MakeRoute(['tab'], 'params')],
    computed: {
      ...mapGetters(['userInfo']),
      currTab() {
        return this.tabs.findIndex(e => e.value === this.tab);
      },
      dfAppList() {
        return this.myTable.find(e => e.end_time > Math.floor(new Date() / 1000)) ? null : this.dfShowApp;
      },
    },
    data() {
      return {
        notice: [
          '登录格灵云平台账号后，输入兑换码即可完成激活',
          '兑换成功后，可享受享受对应权益与服务',
        ],
        tabs: [
          {name: '我的vip', value: 'my', id: 1},
          {name: '订购记录', value: 'record', id: 2},
          {name: '兑换会员', value: 'exchange', id: 3},
        ],
        myTable: [],
        dfShowApp: [],
        myColumns: [
          {key: 'goods_name', title: 'VIP类型', align: 'center'},
          {
            key: 'type_id',
            title: '支付方式',
            align: 'center',
            render: (h, {row, column}) => h('span', ['', '微信', '支付宝', '第三方', '微信app支付', 'IOS支付'][row[column.key]] || row[column.key])
          },
          {
            key: 'start_time',
            title: '获得时间',
            align: 'center',
            render: (h, {row, column}) => h('span', row[column.key] && this.Tools.formatDate(row[column.key], 'Y年M月D日'))
          },
          {
            key: 'end_time',
            title: '到期时间',
            align: 'center',
            render: (h, {row, column}) => h('span', row[column.key] && this.Tools.formatDate(row[column.key], 'Y年M月D日'))
          },
          {
            type: 'ctrl', title: '操作', align: 'center', render: (h, {row, column, index}) => h('div', {
              class: 'add-vip csp',
              on: {
                click: () => this.ShowVip({
                  dfSelect: row.product_id === 1 ? 'tb' : 'gl',
                }),
              }
            }, '续费会员')
          },
        ],

        recordTable: [],
        recordColumns: [
          {
            key: 'price_type',
            title: '类型',
            width: 130,
            render: (h, {row}) => h('div', {
              class: ['dib record-type', ['', 'vip', 'course', '', 'vip-course'][row.type]],
            })
          },
          {key: 'out_trade_no', title: '订单号'},
          {key: 'goods_name', title: '商品名称'},
          {key: 'real_pay', width: 96, title: '实付金额', className: 'record-price'},
          {
            key: 'update_time',
            title: '购买时间',
            width: 146,
            render: (h, {row, column}) => h('span', row[column.key] && this.Tools.formatDate(row[column.key], 'Y年M月D日'))
          },
        ],
        recordCurr: 1,
        recordLimits: 10,
        recordTotal: 0,

        exchangeList: [],
        moreExchange: [],
        exchangeCode: '',

        hotList: [],
      }
    },
    created() {
      this.getRecord();
      this.getMyVip();
      this.getExchange();
      this.getHot();
      this.dfShowApp = this.getDfApp(13, 1);
    },
    methods: {
      getHot() {
        this.http.NEWCoursePlayRanking({uid: this.userInfo.uid, format_id: 1, ...this.Product, is_web: 1}).then(res => {
          this.hotList = res.list.slice(0, 6).map(e => ({...e, element_content: e, type: 1}));
        }).catch(console.log);
      },
      toCourse(item) {
        this.OpenRouter(`/home/${item.format_id === 1 ? 'video' : 'audio'}/details/${item.id}/${item.element_content.type}`);
      },
      userCode() {
        let {exchangeCode: code} = this;
        if (!code) {
          return this.ShowToast('请输入兑换码！');
        }
        this.http.userExchangeCode({
          code,
          uid: this.userInfo.uid,
          type: 1,
          ...this.Product,
          check_token: 1
        }).then(res => {
          this.exchangeCode = '';
          this.ShowToast('兑换成功！');
          this.getExchange();
					window.location.reload()
        }).catch(this.$err);

      },
      recordPageChange(value, type) {
        this.recordCurr = value;
        this.getRecord();
      },
      tabChange(ind) {
        this.tab = this.tabs[ind].value;
      },
      getExchange() {
        this.http.getExchange({
          uid: this.userInfo.uid,
          ...this.Product,
        }).then(res => {
          this.moreExchange = [];
          // for (let i = 3; i > 0; i--) res.list = [...res.list, ...res.list];
          if (res.list.length > 4) {
            this.moreExchange = res.list.splice(4, res.list.length);
          }
          this.exchangeList = res.list;
        }).catch(console.log)
      },
      getMyVip() {
        let appIds = [];
        this.http.NEWMyVip({
          uid: this.userInfo.uid,
          limits: 1000
        }).then(res => {
          res.list.forEach(e => {
            e.logo = '';
            e.name = '';
            if (appIds.includes(e.product_id)) {
              return;
            }
            appIds.push(e.product_id);
            this.getDfApp(e);
          });
          this.myTable = res.list;
        }).catch(console.log);
      },
      getDfApp(...pids) {
        return pids.reduce((r, product_id) => {
          let obj = {
            product_id,
            name: '',
            logo: '',
          };

          if(typeof product_id === 'object'){
            obj = Object.assign(product_id, obj, {product_id: product_id.product_id});
            product_id = obj.product_id;
          }

          this.http.getAppInfo({
            product_id,
            terminal_id: 3,
            channel_id: 26
          }).then(res => {
            obj.name = res.name;
            obj.logo = res.bigimg;
          }).catch(console.log);
          r.push(obj);
          return r;
        }, []);
      },
      getRecord() {
        this.http.NEWOrderList({
          uid: this.userInfo.uid,
          curr: this.recordCurr,
          limits: this.recordLimits,
        }).then(res => {
          this.recordTotal = res.total;
          this.recordTable = res.list;
        }).catch(console.log);
      },
    },
  }
</script>

<style scoped lang="less">
  .hot-list {
    padding: 20px 4px 42px;
    /deep/ .detail-box {
      padding: 0;
      width: 100%;
      font-size: 14px;
      color: #333f4e;
      .name {
        padding-top: 11px;
      }
    }
  }

  /deep/ .vip-inner {
    [class^=ivu-table-column] {
      border-bottom: 0;
      padding: 0;
      font-weight: unset;
      height: 44px;
    }
    .ivu-table {
      &:before {
        display: none;
      }
    }
    .ivu-table {
      color: #333f4e;
      .ivu-table-header {
        color: #999fa6;
        [class^=ivu-table-column] {
          background-color: #f5f7fb;
        }
      }
      .ivu-table-row {
        &:nth-child(2n) {
          [class^=ivu-table-column] {
            background-color: #f5f7fb;
          }
        }
      }
    }
  }

  .tabs {
    padding: 16px 0 8px 32px;
    /deep/ .type-line {
      bottom: -8px;
    }
    /deep/ .curr-type {
      &:not(:first-child) {
        margin-left: 32px;
      }
    }
  }

  .vip-inner {
    padding: 0 18px 48px;
  }

  .my-content {
    .ivu-table-wrapper {
      margin-bottom: 40px;
    }
    /deep/ .add-vip,
    .download {
      display: inline-block;
      padding: 0 16px;
      height: 28px;
      line-height: 28px;
      font-size: 12px;
      color: #fff;
      border-radius: 28px;
      background-color: #1177FF;
      &:hover {
        background-color: #0066ed;
      }
    }
    .tip {
      margin-bottom: 23px;
      font-size: 16px;
      color: #666f7a;
    }
    .app-list {
      margin-left: -16px;
    }
    .app {
      margin-left: 16px;
      padding: 16px;
      width: 128px;
      .app-logo {
        width: 70px;
        height: 70px;
        border: 1px solid #eee;
        border-radius: 16px;
      }
      .app-name {
        margin: 10px 0 15px;
        font-size: 14px;
        color: #333f4e;
      }
    }
  }

  .record-content {
    /deep/ .ivu-table-body {
      .record-price {
        color: #ff2517;
      }
    }
    /deep/ [class^=ivu-table-column] {
      &:first-child {
        .ivu-table-cell {
          padding-left: 30px;
        }
      }
    }
    /deep/ .record-type {
      padding: 0 13px;
      height: 20px;
      font-size: 12px;
      color: #ffa313;
      line-height: 20px;
      background-color: #fff3e0;
      border-radius: 20px;
      &:after {
        content: 'VIP'
      }
      &.course {
        color: #1177ff;
        background-color: #e0eeff;
        &:after {
          content: '课程'
        }
      }
      &.vip-course {
        color: #7a3dff;
        background-color: #eae0ff;
        &:after {
          content: 'VIP / 课程'
        }
      }
    }
  }

  .exchange-content {
    .exchange-top {
      margin-bottom: 40px;
      border-radius: 8px;
    }
    .user-phone {
      margin-bottom: 32px;
      padding: 0 44px;
      font-size: 12px;
      color: #999fa6;
    }
    .user-phone-inner {
      font-size: 14px;
      color: #666f7a;
    }
    .change-user {
      margin-left: 14px;
      color: #1177ff;
      .change {
        margin-right: 4px;
      }
    }
    .code-input {
      margin-bottom: 32px;
      padding: 0 44px;
      > :nth-child(n) {
        height: 40px;
        line-height: 40px;
        border-radius: 40px;
      }
      &-inner {
        width: 588px;
        margin-right: 36px;
        font-size: 14px;
        color: #333f4e;
        border: 1px solid #1177FF;
        &::placeholder {
          color: #999fa6;
        }
      }
      .exchange-button {
        font-size: 14px;
        color: #fff;
        background-color: #1177ff;
        &:hover {
          background-color: #0066ed;
        }
      }
    }
    .notice {
      margin-bottom: 58px;
      padding: 0 44px;
      font-size: 12px;
      line-height: 20px;
      color: #999fa6;
      counter-reset: count;
      &-tip {
        margin-bottom: 12px;
        font-size: 14px;
        line-height: 1;
      }
      &-row {
        &:before {
          counter-increment: count;
          content: counter(count) ". ";
        }
        .help {
          color: #1177ff;
          text-decoration: underline;
        }
      }
    }
    .subtitle {
      padding-left: 14px;
      font-size: 18px;
      color: #525252;
      line-height: 1;
      &.change-his {
        margin-bottom: 19px;
      }
      &.remark {
        margin-bottom: 20px;
      }
    }
    .change-list {
      margin: -10px 0 40px 5px;
    }
    .change-item {
      margin-top: 10px;
      padding: 0 16px;
      width: 416px;
      height: 80px;
    }
    .exchange {
      &-detail {
        font-size: 14px;
        color: #525252;
      }
      &-code {
        font-size: 12px;
        color: #999FA6;
      }
      &-time {
        font-size: 12px;
        color: #cccfd2;
      }
    }
    .no-exchange {
      height: 191px;
      line-height: 191px;
      font-size: 14px;
      color: #999fa6;
    }
    .remark-list {
      margin-bottom: 24px;
    }

    .more-remark {
      width: 383px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      color: #bd6917;
      background: linear-gradient(-45deg, #FFD28C, #FFD99E);
      border-radius: 40px;
      &:hover {
        background: linear-gradient(-45deg, #FFCB79, #FFCF84);
      }
    }
    .show-all {
      &:hover {
        color: #1177ff;
        &:after {
          background-color: #1177ff;
        }
      }
    }
  }

  .user-vip {
    /deep/ .ivu-table-stripe {
      /*.ivu-table-fixed-body {*/
      .ivu-table-row-hover {
        td {
          background-color: unset;
        }
      }
      /*}*/
    }

    .only-big {
      /deep/ .img-bg {
        width: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
</style>